import { Box } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';

interface AiSideTagProps {
    muted?: boolean;
}

/** סרט אנכי בצד הכרטיס — לכל יכולת עם AI */
const AiSideTag = ({ muted }: AiSideTagProps) => (
    <Box
        aria-label="AI"
        sx={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            insetInlineEnd: 0,
            width: 34,
            zIndex: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.6,
            color: '#ffffff',
            background: muted
                ? 'linear-gradient(180deg, #9aa3ad 0%, #7b8794 52%, #6a7380 100%)'
                : 'linear-gradient(180deg, #d4c4ff 0%, #c4b5fd 48%, #b39dff 100%)',
            boxShadow: 'inset 8px 0 16px rgba(8, 24, 45, 0.18)',
            pointerEvents: 'none'
        }}
    >
        <AutoAwesome sx={{ fontSize: 14, opacity: 0.95 }} />
        <Box
            sx={{
                writingMode: 'vertical-rl',
                transform: 'rotate(180deg)',
                fontWeight: 900,
                fontSize: 12,
                letterSpacing: '0.28em',
                lineHeight: 1
            }}
        >
            AI
        </Box>
    </Box>
);

export default AiSideTag;
